import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("button", {
      class: "burger",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
    }, " ☰ "),
    _createElementVNode("nav", {
      class: _normalizeClass({ open: _ctx.isMenuOpen })
    }, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "nav-link",
        onClick: _ctx.closeMenu
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("🌺Accueil")
        ])),
        _: 1,
        __: [4]
      }, 8, ["onClick"]),
      _createVNode(_component_router_link, {
        to: "/collection",
        class: "nav-link",
        onClick: _ctx.closeMenu
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("🌺Cartes Postales")
        ])),
        _: 1,
        __: [5]
      }, 8, ["onClick"])
    ], 2),
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["prevent"]))
    }, [
      _createElementVNode("input", {
        type: "text",
        value: _ctx.searchInput,
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
        placeholder: "Rechercher une carte..."
      }, null, 40, _hoisted_2),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
        class: "searchButton",
        type: "submit"
      }, "🔍")
    ], 32)
  ]))
}